import { breakpoints } from '@etg/wings';
import { useProperty } from '@eti/providers';
import type { Dispatch, RefObject, SetStateAction } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'usehooks-ts';
import { AIRLINES } from '../../../../constants/searchFiltersConstants';
import DesktopFilters from '../search-filters/v3/DesktopFilters';
import type { Filters } from '../search-filters/v3/MobileFilters';
import MobileFilters from '../search-filters/v3/MobileFilters';
import FloatingSaveTripButton from './FloatingSaveTripButton';
import { useResultPageContext } from './contexts/ResultPageContext';

interface ResultSearchFiltersProps {
  onClear: () => void;
  onFilter: (filter: any) => void;
  selectedFilters?: Filters;
  setIsItineraryDrawerSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
  sidebarRef: RefObject<HTMLElement>;
}

type DestinationState = {
  fromDestinationPage?: boolean;
};

const ResultSearchFilters = ({
  onClear,
  onFilter,
  selectedFilters,
  setIsItineraryDrawerSelfTransferModalOpen,
  sidebarRef,
}: ResultSearchFiltersProps) => {
  const { p } = useProperty();
  const { searchData } = useResultPageContext();
  const isAirlinesEnabled = p('Result.Filter.Airlines.Enabled');
  const isMobile = useMediaQuery(`(max-width: ${breakpoints._970})`);
  const history = useHistory<DestinationState>();
  const navigatingFromDestinationPage = history?.location?.state?.fromDestinationPage;
  const hasSelectedAirlines = selectedFilters?.[AIRLINES]?.length;

  const shouldShowAllAirlines =
    navigatingFromDestinationPage &&
    isAirlinesEnabled &&
    hasSelectedAirlines &&
    searchData?.filteredFlightsCount === 0;

  if (shouldShowAllAirlines) {
    onFilter({ [AIRLINES]: null });
  }

  return isMobile ? (
    <>
      <FloatingSaveTripButton
        setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
      />
      <MobileFilters onClear={onClear} onFilter={onFilter} selectedFilters={selectedFilters} />
    </>
  ) : (
    <DesktopFilters
      onClear={onClear}
      onFilter={onFilter}
      selectedFilters={selectedFilters}
      setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
      sidebarRef={sidebarRef}
    />
  );
};

export default ResultSearchFilters;
